import { useState } from "react";
import MobileFilterButton from "./components/MobileFilterButton";
import NitroAutocomplete from "./components/NitroAutocomplete";

const NitroFilter = ({
  isFavoriteOrigins,
  value,
  setValue,
  placeholder,
  Icon,
  data,
  isMobile,
  type,
  disabled,
  size,
  config,
  variant,
  autocompleteOptions,
  isLoadingOptions,
}: {
  isFavoriteOrigins?: boolean;
  value: string;
  setValue: (value: string) => void;
  placeholder: string;
  Icon?: any;
  data:
    | { options: { label: string; value: string }[]; getRecords?: undefined }
    | {
        getRecords: (v: string) => Promise<{ label: string; value: string }[]>;
        options?: undefined;
      };
  isMobile?: boolean;
  type?: "popup" | "autocomplete";
  disabled?: boolean;
  size?: "small" | "medium";
  config?: {
    shadow?: boolean;
    opaque?: boolean;
    customPaper?: boolean;
    autoFocus?: boolean;
    disableFilter?: boolean;
    inputRef?: React.MutableRefObject<any> | null;
    valueRequired?: boolean;
    className?: string;
    disableClearable?: boolean;
    hideDropdownIcon?: boolean;
  };
  variant?: "standard" | "outlined" | "filled";
  autocompleteOptions?: {
    renderOption?: (params: any, option: any) => JSX.Element;
    filterOptions?: (options: any[]) => any[];
  };
  isLoadingOptions?: boolean;
}) => {
  const [open, setOpen] = useState(false);

  if (isMobile) {
    return (
      <MobileFilterButton
        inputRef={config?.inputRef}
        open={open}
        setOpen={setOpen}
        value={value}
        setValue={setValue}
        placeholder={placeholder}
        Icon={Icon}
        data={data}
        valueRequired={config?.valueRequired}
        variant={type === "autocomplete" ? "outlined" : "text"}
      />
    );
  }

  return (
    <NitroAutocomplete
      isFavoriteOrigins={isFavoriteOrigins || false}
      value={value}
      setValue={setValue}
      placeholder={placeholder}
      data={data}
      variant={variant}
      size={size}
      disabled={disabled}
      config={config}
      autocompleteOptions={autocompleteOptions}
      isLoadingOptions={isLoadingOptions}
      isMobile={isMobile}
    />
  );
};

export default NitroFilter;
